import HelpCenter from '../../Web/HelpCenter'

export default HelpCenter
